<template lang="pug">
div
  v-navigation-drawer(app='' right='' disable-route-watcher='' v-model='show_navbar' v-if='idx.length > 0')
    v-subheader
      span {{ $t(&quot;category&quot;) }}
    v-divider
    v-list(nav='' dense='')
      v-list-item(v-for='i in idx' :key='i.section' :to="{name: 'CollectionHome2', params: {mainset_id, subset: i.section.slice(0, -7)}}" replace='')
        v-list-item-title {{ sec_t(i) }}
  v-container.fill-height(style='max-width: 1200px; min-width: 320px; align-content: start; justify-content: center;')
    v-row
      v-col
        search-bar(:mainset_id='mainset_id')
    v-row
      v-col
        set-info(:setsn="mainset_id")
    v-row
      v-col
        v-card
          v-list(dense='')
            template(v-for='i in menu')
              template(v-if='i.uniname == null')
                v-subheader(:id="i.section + '_a'" :key="i.section + '_a'") {{ sec_t(i) }}
                v-divider(:key="i.section + '_d'")
              v-list-item(v-else='' :key='i.section + i.uniname' :to="{name: 'JournalHome', params: { uniname: i.uniname } }")
                v-list-item-content(v-text='jname(i.uniname)')
</template>
<script>
import {debug} from 'loglevel'
// import router from "@/router"
import store from "@/store"
import { toc_options, jinfo } from "@/api";
import SearchBar from "@/components/SearchBar"
import SetInfo from "@/components/SetInfo"
import i18n from '@/i18n'

function build_menu(mainset_id, toc_options) {
  // debug('toc', toc_options);
  // 雄獅庫特別修正，在庫目錄不列出廣告
  const skip_lip = !store.state.test
  function menu_from_childs(childs, section_id = null) {
    var menu = [],
      idx = []
      childs.forEach((v) => {
        if (v.id.endsWith("_subset")) {
          idx.push({ name: v.name, uniname: null, section: v.id })
          menu.push({ name: v.name, uniname: null, section: v.id })
          const [m,] = menu_from_childs(v.children, v.id)
          menu = menu.concat(m)
        } else {
          if(!skip_lip || v.id != 'lip') {
            menu.push({ name: v.name, section: section_id, uniname: v.id })
          }
        }
      })
    // debug(menu, idx)
    return [menu, idx]
  }
  for (var i = 0; i < toc_options.length; i++) {
    if (toc_options[i].id.startsWith(mainset_id)) {
      return menu_from_childs(toc_options[i].children)
    }
  }
}

export default {
  name: "CollectionHome",
  components: {
    SearchBar, SetInfo,
  },
  methods: {
    jname(uniname) {
      if(i18n.locale == 'en') {
        return jinfo[uniname][this.$en('journal_en_name')]
      }
      else if(i18n.locale == 'zh-CN') {
        return jinfo[uniname][this.$en('journal_cn_name')]
      }
      return jinfo[uniname][this.$en('journal_name')]
    },
    sec_t(i) {
      const v = i.section.split('_').slice(0, -1)
      if(v[0] == 'cbs') return this.$t(v.join('.'))
      let tt = []
      for(let i = 0; i < v.length; i++) {
        tt.push(this.$t('c.' + v[i]))
      }
      return tt.join('/')
    },
    gotoSubset(subset) {
      this.$vuetify.goTo('#' + subset + '_a')
    },
    load_mainset(mainset_id) {
      [this.menu, this.idx] = build_menu(mainset_id, toc_options)
      return Promise.resolve()
      // return get_toc().then((toc)=>{
      //   [this.menu, this.idx] = build_menu(mainset_id, toc)
      // })
    },
  },
  watch: {
    mainset_id: {
      handler(mainset_id) {
        [this.menu, this.idx] = [[], []]
        this.load_mainset(mainset_id)
        this.$store.commit('set_mainset', mainset_id)
        this.mainset_name = this.$store.state.mainset_name
      },
      immediate: true,
    },
    subset(subset) {
      if(subset === undefined) {
        this.$vuetify.goTo(0)
      }
      else {
        this.gotoSubset(subset + '_subset')
      }
    },
  },
  mounted() {
    this.update_subset = this.subset
    this.load_mainset(this.mainset_id).then(()=>{
      this.update_subset = this.subset
    })
  },
  updated() {
    // debug('update', this.update_subset)
    if(this.update_subset !== undefined) {
      const subset = this.update_subset
      this.update_subset = undefined
      this.gotoSubset(subset + '_subset')
    }
  },
  created() {
    this.$store.subscribe((mutation) => {
      if (mutation.type == "toggle_context_sidebar") {
        this.show_navbar = !this.show_navbar
      }
    })
  },
  data() {
    return {
      jinfo: jinfo,
      q: "",
      menu: [],
      idx: [],
      update_subset: undefined,
      mainset_name: undefined,
      show_navbar: true,
    };
  },
  props: {
    mainset_id: {},
    subset: {},
  },
};
</script>
